import chroma from 'chroma-js';

export const getItemColors = (
  node: HTMLElement | undefined,
  currentTheme: any,
) => {
  const baseColor =
    (node && getComputedStyle(node).getPropertyValue('background-color')) ||
    '#FFFFFF';

  const baseColorLuminosity = chroma(baseColor).get('hsl.l');

  let tintColor: string;

  if (baseColorLuminosity < 0.5) {
    tintColor = chroma(baseColor).brighten(0.3).hex();
  } else if (baseColorLuminosity < 0.9) {
    tintColor = chroma
      .blend(baseColor, currentTheme.COLOR.GREY[300], 'multiply')
      .hex();
  } else {
    tintColor = chroma
      .blend(baseColor, currentTheme.COLOR.GREY[100], 'multiply')
      .hex();
  }

  return { baseColor, tintColor, baseColorLuminosity };
};
